import HorseDetailsPage from "./HorseListsPage";

export default HorseDetailsPage;
